import { render, staticRenderFns } from "./ContainerContactsPreview.vue?vue&type=template&id=05b6f874"
import script from "./ContainerContactsPreview.vue?vue&type=script&lang=js"
export * from "./ContainerContactsPreview.vue?vue&type=script&lang=js"
import style0 from "./ContainerContactsPreview.vue?vue&type=style&index=0&id=05b6f874&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports